import * as React from "react";
const SvgFiRrMagicWand = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-magic-wand_svg__a)">
      <path
        fill="#062147"
        d="M18 9.064a3.05 3.05 0 0 0-.9-2.164 3.14 3.14 0 0 0-4.334 0L.9 18.77a3.064 3.064 0 0 0 4.33 4.33L17.1 11.231a3.05 3.05 0 0 0 .9-2.167M3.816 21.688a1.087 1.087 0 0 1-1.5 0 1.06 1.06 0 0 1 0-1.5l7.77-7.77 1.504 1.505zM15.688 9.816 13 12.506 11.5 11l2.69-2.688a1.063 1.063 0 1 1 1.5 1.5zM4.863 2.856l1.55-.443.442-1.55a1.191 1.191 0 0 1 2.29 0l.442 1.55 1.55.442a1.19 1.19 0 0 1 0 2.29l-1.55.442-.442 1.55a1.191 1.191 0 0 1-2.29 0l-.442-1.55-1.55-.442a1.191 1.191 0 0 1 0-2.29m18.274 14.29-1.55.441-.442 1.55a1.19 1.19 0 0 1-2.29 0l-.442-1.55-1.55-.442a1.191 1.191 0 0 1 0-2.29l1.55-.442.442-1.55a1.19 1.19 0 0 1 2.29 0l.442 1.55 1.55.442a1.191 1.191 0 0 1 0 2.29M17.755 2.5l1.356-.387.39-1.358a1.042 1.042 0 0 1 2 0l.386 1.356 1.356.387a1.042 1.042 0 0 1 0 2l-1.356.387-.387 1.36a1.042 1.042 0 0 1-2 0l-.387-1.356-1.358-.389a1.042 1.042 0 0 1 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-magic-wand_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMagicWand;
